import BsIcon from "./BsIcon";
import BsIconToggle from "./BsIconToggle";

export default Vue => {
    Vue.component(BsIcon.name, BsIcon);
    Vue.component(BsIconToggle.name, BsIconToggle);
};
